import { render, staticRenderFns } from "./partInquriy.vue?vue&type=template&id=009db6d0&scoped=true&"
import script from "./partInquriy.vue?vue&type=script&lang=js&"
export * from "./partInquriy.vue?vue&type=script&lang=js&"
import style0 from "./partInquriy.vue?vue&type=style&index=0&id=009db6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009db6d0",
  null
  
)

export default component.exports